import { render, staticRenderFns } from "./AutoAssignRules.vue?vue&type=template&id=62cd5d3e&"
import script from "./AutoAssignRules.vue?vue&type=script&lang=js&"
export * from "./AutoAssignRules.vue?vue&type=script&lang=js&"
import style0 from "./AutoAssignRules.vue?vue&type=style&index=0&id=62cd5d3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports